import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Waitlist entries
 */
export const fetchWaitlistItems = createAsyncThunk(
  "waitlist/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/waitlist`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
       window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
